import _ from 'lodash';

import { GetterTree } from 'vuex';
import { RootState } from '../types';
import { MaintenancejobsState } from './types';

import { Maintenancejob } from '@/models';

/**
 * Getters
 *
 * Vuex allows us to define "getters" in the store.
 * - You can think of them as computed properties for stores.
 * - Like computed properties, a getter's result is cached based on its dependencies,
 *   and will only re-evaluate when some of its dependencies have changed.
 */
export const getters: GetterTree<MaintenancejobsState, RootState> = {

	/**
	 * Get the current Maintenancejob
	 * 
	 * @param { MaintenancejobsState } state
	 * @returns Current client
	 */
	 current: (state: MaintenancejobsState): Maintenancejob|undefined => {
		return state.current;
	},

	/**
	 * Get the list of Maintenancejobs
	 * 
	 * @param { MaintenancejobsState } state
	 * @returns List of maintenancejobs
	 */
	list: (state: MaintenancejobsState): Maintenancejob[]|undefined => {
		return state.list;
	},

	/**
   * The updates which have been made since creating/loading/last-saving the current maintenancejob
   */
	 hasUnsavedChanges: (state: MaintenancejobsState): boolean => state.updates.length > 0,
}